import { render, staticRenderFns } from "./EventModalPassesUsers.vue?vue&type=template&id=27bffecf&scoped=true"
import script from "./EventModalPassesUsers.vue?vue&type=script&lang=js"
export * from "./EventModalPassesUsers.vue?vue&type=script&lang=js"
import style0 from "./EventModalPassesUsers.vue?vue&type=style&index=0&id=27bffecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bffecf",
  null
  
)

export default component.exports